import AutolineSettingsTab from './autoline-settings';

export default AutolineSettingsTab;
